import styled from 'styled-components';

export const SurgeryVerticalWaitingStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  p {
    margin: 0;
  }
`;

export const Thead = styled.section`
  height: 9vh;
  line-height: 9vh;
  display: flex;
  flex-direction: row;
  background-color: #5a5490;

  p {
    width: 20vw;
    text-align: center;
    color: #fff;
    font-size: 5vh;
    font-weight: 600;
  }

  .wide {
    width: 30vw;
  }
`;

export const Patients = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 0;
  list-style: none;
`;

export const Patient = styled.li`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: lightgray;

  &:nth-child(2n) {
    background-color: #88a2bc;
  }

  p {
    width: 20vw;
    text-align: center;
    color: #000;
    font-size: 5.5vh;
    font-weight: 600;
  }
  .wide {
    width: 30vw;
  }
`;

export const CustomPTag = styled.p<{
  family?: string;
  fz?: number;
  fw?: boolean;
  color?: string;
  align?: string;
}>`
  font-family: ${(props) => props.family};
  font-size: calc(${(props) => props.fz}vh / 11);
  font-weight: ${(props) => (props.fw ? 'bold' : 'normal')};
  color: ${(props) => props.color};
  text-align: ${(props) => props.align ?? 'left'};
`;
